import {
	Box,
	Input,
	InputGroup,
	InputLeftElement,
	Text,
	useDisclosure,
	useOutsideClick,
} from "@chakra-ui/react";
import { t } from "i18next";
import parsePhoneNumber from "libphonenumber-js";
import React, { useMemo, useRef, useState } from "react";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";
import { COUNTRIES, ICountry } from "./components/search-country/countries";
import { SearchCountry } from "./components/search-country/search-country.view";

interface IProps {
	onChange: (value: string) => void;
	value: string;
	defaultCountry?: ICountry;
}

export function InputPhoneNumber(props: IProps) {
	const ref = useRef(null);
	useOutsideClick({ ref: ref, handler: () => onClose() });
	const { isOpen, onToggle, onClose } = useDisclosure();
	const rawNumber = useMemo(() => parsePhoneNumber(props.value), [props.value]);

	const [nationalNumber, setNationalNumber] = useState(
		rawNumber?.nationalNumber ?? props.value
	);

	const [dialCode, setDialCode] = useState(
		rawNumber?.countryCallingCode ?? props.defaultCountry?.dial_code ?? ""
	);

	const [countryFlag, setCountryFlag] = useState(() => {
		const country = COUNTRIES.find((c) => {
			return c.code === rawNumber?.country;
		});

		if (country) {
			return country.flag;
		}

		return props.defaultCountry?.flag ?? "";
	});

	function handleCountryChange(value: ICountry) {
		setDialCode(value.dial_code);
		setCountryFlag(value.flag);
		props.onChange(`${value.dial_code}${nationalNumber}`);
		onClose();
	}

	function handleNationalNumberChange(e: React.ChangeEvent<HTMLInputElement>) {
		const value = e.target.value;
		const parsed = parsePhoneNumber(value);

		if (parsed) {
			props.onChange(`+${parsed.countryCallingCode}${parsed.nationalNumber}`);
			setNationalNumber(parsed.nationalNumber);
			setDialCode(parsed.countryCallingCode);
			setCountryFlag(
				COUNTRIES.find((c) => c.code === parsed.country)?.flag ?? ""
			);
			return;
		}

		setNationalNumber(value);
		props.onChange(`${dialCode}${value}`);
	}

	return (
		<Box ref={ref} position="relative">
			<InputGroup>
				<InputLeftElement
					borderLeftRadius="md"
					width="5em"
					cursor="pointer"
					onClick={onToggle}
					_hover={{
						backgroundColor: "gray.100",
					}}
				>
					<Text as="span" mr={3}>
						{countryFlag}
					</Text>
					{isOpen ? (
						<TbChevronUp color="gray.500" />
					) : (
						<TbChevronDown color="gray.500" />
					)}
				</InputLeftElement>

				<Input
					pl="5.5em"
					type="tel"
					autoComplete="tel"
					value={nationalNumber}
					placeholder={t("Phone number")}
					onChange={handleNationalNumberChange}
				/>
			</InputGroup>

			{isOpen ? <SearchCountry onChange={handleCountryChange} /> : null}
		</Box>
	);
}
